<template>
  <div class="row">
    <div
        :id="question.id"
        :class="`col-4 py-2 ${question.answered ? '' : 'opacity-30'}`">
      {{question.text}}
    </div>

    <div class="col-8">
      <div v-for="field in question.fields" :key="field.id">
        <QuestionnaireField
            v-if="typeof field.answer !== 'undefined'"
            :field="field"
            :comment-answer="commentAnswer" />
      </div>
    </div>
  </div>
</template>

<script>
  import QuestionnaireField from './Field';

  export default {
    name: 'QuestionnaireQuestion',

    components: {QuestionnaireField},

    props: ['question', 'commentAnswer'],

    data() {
      return {};
    },
  };
</script>
